import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import './index.css'
import './i18n'
import App from './App.jsx'
import { msalInstance } from './auth/msalConfig'

// MSAL must be initialized and any redirect response handled before render.
msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise()
}).then(() => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </StrictMode>,
  )
}).catch((err) => {
  console.error('MSAL initialization failed', err)
  const root = document.getElementById('root')
  if (root) {
    root.innerHTML =
      '<div style="font-family:sans-serif;padding:2rem;color:#666;text-align:center">' +
      'Sign-in failed to initialize. Please reload the page or contact an administrator.</div>'
  }
})
